module.exports = __webpack_public_path__ + "static/media/logo_white.df1fe1a0.png";